import classes from "./TagsDisplay.module.css";
import domain from "../../domain";
import { CgArrowsMergeAltH } from "react-icons/cg";
import { useState, useRef } from "react";

import {
  getMergedTagDatalocallyById,
  mergeTagData,
  mergeTags,
} from "../../util/foodReview/extractData";
import Tag from "./Tag";
import { storeMergedDatalocallyById ,deleteOlderMergedTags } from "../../util/foodReview/mergingTagsUtils";

export default function TagsDisplay({ tagsContainer, setTagsContainer, bId }) {
  // let DbData = fetchMergedDataFromDB();
  // //console.log(DbData);

  //console.log("rendering tagsDisplay");
  //
  //console.log(tagsContainer);
  //  DO NOT MANIPULATE DOM STRUCTURE IN REACT> USE USTATE AND INDIRECTLY CHNAGE DOM

  const [mergeContainer, setMergeContainer] = useState([]);
  // const [tagsContainer, setTagsContainer] = useState(data);
  const [mergeMode, setMergeMode] = useState(false);
  const mergeData = useRef([]);

  function tagEditHandler() {
    setMergeMode((p) => !p);
  }

  function tagMergeClickHandler(e) {
    let idSelected = e.target.childNodes[0].innerHTML;
    // below containerId will identify from where we click either
    // tag container or merging conatiner so thta we can decide to select or deselct.
    let containerId = e.target.parentNode.id;

    if (containerId == "tagsCont") {
      // means tags are inside tagsContainer hence need to be merged.
      // else tags are in temporary merge container and need to be deselected n put back
      // inside tags container.
      tagSelectionHandler(idSelected, tagsContainer);
    } else {
      tagDeselectionHandler(idSelected, mergeContainer);
    }
  }

  function tagSimpleClickHandler(e) {
    //console.log("simple click");
  }

  function tagSelectionHandler(id, data) {
    // this function puts data item with id same as input id
    // and item is added to merging state variable.

    let obj = {};

    // we filter all items and if id matches then store in obj and remove from tagData.
    const newTagData = data.filter((item) => {
      if (item.mainId == id) {
        obj = { ...item };
        return false;
      } else return true;
    });

    // now we place the obj inside mergeContainer state variable

    setMergeContainer((prev) => {
      return [...prev, obj];
    });

    // and we update tagContainer with newData removing matching id item

    setTagsContainer(newTagData);
  }

  function tagDeselectionHandler(id, data) {
    // this function puts data item with id same as input id
    // and item is added to merging state variable.

    let obj = {};

    //we loop through mergeContainer and if id matches remove object from it.
    // and add matched item in tag container.
    const newTagData = data.filter((item) => {
      if (item.mainId == id) {
        obj = { ...item };
        return false;
      } else return true;
    });

    // now we place the obj inside mergeContainer state variable

    setTagsContainer((prev) => {
      return [...prev, obj];
    });

    // and we update tagContainer with newData removing matching id item

    setMergeContainer(newTagData);
  }

  function mergeTagsHandler() {
    /** COMPLICATIONS arise when we merge tags and one of the tags was
     * already merged before so will should delet its data from place
     * where we store info about merged tags else data would be repeated.
     */

    // const storedMergedInfo1 = JSON.parse(
    //   sessionStorage.getItem("mergedTagsData")
    // );
    const storedMergedInfo = getMergedTagDatalocallyById(bId);

    // now we will first check if tags coming in for merging were already merged
    // if yes then remove such tags from storedMergedInfo. first.

    //STARTS == Removing merged tags form stored inofr
//console.log("storedMergedInfo before removal", storedMergedInfo);
    let newDataAfterRemoval = storedMergedInfo.filter((data) => {
      let isPresent = false;
      let checkid = data.mainId;

      mergeContainer.forEach((item) => {
        if (checkid == item.mainId) isPresent = true;
      });

      if (!isPresent) return true;
    });

    // we also remove merged tags if older than 180 days.
  let newDataAfterExpiryCheck = deleteOlderMergedTags(newDataAfterRemoval);

    // ENDS removal of already merged tag if they are being merged again with some tag.

    const output = mergeTagData(mergeContainer);

    // we are storing merged Tags infor in Local Storage. in array we store
    // actual tags object which can be displayed when viewing.

    newDataAfterExpiryCheck.push(output);

    //DO IT LATER BUT DO IT.
    //step 1.5 to update this merged data on DB.
    //console.log(newDataAfterExpiryCheck);
    fetch(`${domain}/api/mergingFtags`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: bId, data: newDataAfterExpiryCheck }),
    })
      .then((response) => {
        //console.log("then case");
        //console.log(response);

        // Now we make changes locally once change is made in DB.
        // sessionStorage.setItem(
        //   "mergedTagsData",
        //   JSON.stringify(newDataAfterRemoval)
        // );
        storeMergedDatalocallyById(newDataAfterExpiryCheck, bId);

        return response.json();
      })

      .catch((err) => {
        //console.log("catch case");
        alert("Could Not Save in DataBase, pl try after some time.");
        //console.log(err);
      });

    // step2 is to include output to tagsContainer data.
    setTagsContainer((prev) => {
      return [...prev, output];
    });

    //step 3 is to clear data form mergeContaine state
    setMergeContainer([]);
  }

  deleteOlderMergedTags(getMergedTagDatalocallyById(bId));
  return (
    <>
      <div className={classes.container}>
        <div
          className={`${classes.mergingTagsSuperContainer} ${
            mergeMode ? classes.visible : classes.hide
          }`}
        >
          {" "}
          <div className={classes.mergingTagsContainer} id="mergeCont">
            {mergeContainer.map((td) => {
              return (
                <Tag
                  key={`merge ${td.mainId}`}
                  id={td.mainId}
                  title={td.data[0].foodName}
                  onClickHandler={tagMergeClickHandler}
                />
              );
            })}
          </div>{" "}
          <div
            className={`${classes.mergeButtonContainer} ${
              mergeContainer.length < 2 && classes.hide
            }`}
          >
            {" "}
            <button onClick={mergeTagsHandler}>merge</button>
          </div>
        </div>
        <div className={classes.tagsSuperContainer}>
          <div
            className={``}
            onClick={function (e) {
              tagEditHandler();
            }}
          >
            <div
              className={`${classes.iconBox} ${classes.tooltip} ${
                mergeMode && classes.iconBoxActive
              }`}
            >
              <CgArrowsMergeAltH className={classes.icon} />{" "}
              <span className={classes.tooltiptext}>Merge tags</span>
            </div>
          </div>
          <div className={`${classes.tagsContainer} `} id="tagsCont">
            {tagsContainer.map((td) => {
              return (
                <Tag
                  key={td.mainId}
                  mergeMode={mergeMode}
                  id={td.mainId}
                  title={td.data[0].foodName}
                  onClickHandler={
                    mergeMode ? tagMergeClickHandler : tagSimpleClickHandler
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
